// App.tsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Header from './widgets/headers';
import Footer from './widgets/footer';
import Home from './components/home';
import Contact from './components/contact';

// Import your CSS
import './css/header.css';
import './css/footer.css'; // Add this
import './index.css';

// Font Import
import "@fontsource/inter";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import Pricing from './components/pricing';
import Download from './components/download';
import About from './components/about';

const App: React.FC = () => {
  return (
    <Router>
      <Header />
      <div className="app-wrapper">
        <div className="app-container">
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/about" element={<About />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/download" element={<Download />} />
              <Route path="/login" element={<div>Login Page</div>} />
              <Route path="/signup" element={<div>Sign Up Page</div>} />
              <Route path="/old-home" element={<Navigate to="/" replace />} />
              <Route path="*" element={<div className="not-found">404 - Page Not Found</div>} />
            </Routes>
          </main>
        </div>
        <Footer />
      </div>
    </Router>
  );
};

export default App;